import { render, staticRenderFns } from "./ReservationRulesProblemPopup.vue?vue&type=template&id=06f6a7ab&scoped=true&"
import script from "./ReservationRulesProblemPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationRulesProblemPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReservationRulesProblemPopup.vue?vue&type=style&index=0&id=06f6a7ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6a7ab",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ReservationRulesProblemPopup.vue
// module id = null
// module chunks = 